import { WindowEvent as MatchboxWindowEvent } from '@sparkpost/matchbox';

const WindowEvent = MatchboxWindowEvent;

export default WindowEvent;
